module.exports = __webpack_public_path__ + "img/spider_webs.e5d829d6.jpg";